import { useState, useRef } from "react";

export const useMessages = (processFeedback) => {
  const [messages, setMessages] = useState([]);
  const messageIdRef = useRef(0);

  const addMessage = async (message, sender, options = {}) => {
    const { links, messageId } = options;
    const nextMessageId = ++messageIdRef.current;
    const newMessage = {
      id: nextMessageId, // Internal ID
      messageId: messageId, // ID from the backend, if exists
      text: message,
      sender: sender,
      timestamp: new Date(),
      onFeedback: processFeedback,
      positiveFeedback: false,
      negativeFeedback: false,
      feedbackMessage: "",
    };

    if (links) {
      newMessage.links = links;
    }

    console.log("Messages before adding:", messages);
    setMessages((prevMessages) => [...prevMessages, newMessage]);
  };

  const resetMessages = () => {
    setMessages([]);
    messageIdRef.current = 0;
  };

  const restoreMessages = (restoredMessages) => {
    if (!Array.isArray(restoredMessages) || restoredMessages.length === 0) {
      resetMessages();
      return;
    }

    const maxId = restoredMessages.reduce((max, message) => Math.max(max, message.id || 0), 0);
    messageIdRef.current = maxId;

    setMessages(
      restoredMessages.map((message) => ({
        ...message,
        timestamp: message.timestamp ? new Date(message.timestamp) : new Date(),
        onFeedback: processFeedback,
      }))
    );
  };

  return {
    messages,
    addMessage,
    resetMessages,
    restoreMessages,
  };
};

export const truncateContentTo32Kb = (content) => {
  const truncationNote = "[Note: The forwarded email content has been truncated due to size limitations.]";

  // Convert the string to a byte array
  let encoder = new TextEncoder();
  let byteArray = encoder.encode(content);

  // Check if the byte array exceeds 32KB
  const maxBytes = 32 * 1024; // 32KB
  const noteBytes = encoder.encode(truncationNote).length + 1; // Get byte size of the note

  if (byteArray.length + noteBytes > maxBytes) {
    // Truncate the byte array to accommodate the truncation note
    byteArray = byteArray.slice(0, maxBytes - noteBytes);

    // Convert the truncated byte array back to a string
    let decoder = new TextDecoder();
    content = decoder.decode(byteArray);

    // Add the truncation note
    content += "\n" + truncationNote;
  }

  return content;
};
